import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { lenisRef } from "../lib/smooth";
import { SERVICES } from "../data/site";
import { PageHero } from "../components/PageHero";
import { Frame, Lines, Reveal } from "../components/motion";
import { Method } from "../components/home/Method";
import { ContactCta } from "../components/ContactCta";

const ServiceBlock = ({ s, i }) => {
  const flip = i % 2 === 1;
  return (
    <section id={s.id} className="scroll-mt-24 border-t border-ink/10 px-5 py-20 sm:px-10 md:py-32 lg:px-16" data-testid={`service-${s.id}`}>
      <div className="grid grid-cols-12 gap-y-12 lg:gap-x-10">
        <Frame src={s.img} alt={`${s.title} — B Digital Studio`} className={`col-span-12 aspect-[4/5] sm:col-span-8 lg:col-span-5 ${flip ? "lg:order-2 lg:col-start-8" : ""}`} />
        <div className={`col-span-12 lg:col-span-6 ${flip ? "lg:order-1 lg:col-start-1" : "lg:col-start-7"} lg:self-center`}>
          <Reveal><span className="font-serif text-6xl text-teal/30 md:text-8xl">{s.n}</span></Reveal>
          <Lines lines={[s.title]} className="mt-4 text-4xl leading-[1.1] md:text-5xl" />
          <Reveal delay={0.1}>
            <p className="mt-8 font-serif text-xl leading-snug text-teal md:text-2xl">{s.lead}</p>
            <p className="mt-5 text-base leading-relaxed text-ink/80 md:text-lg">{s.text}</p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="eyebrow mt-10">Cosa include</p>
            <ul className="mt-4 border-t border-ink/15">
              {s.includes.map((x) => (
                <li key={x} className="flex items-center gap-4 border-b border-ink/15 py-3.5 text-sm md:text-base">
                  <span className="h-1.5 w-1.5 shrink-0 rounded-full bg-teal" aria-hidden="true" />{x}
                </li>
              ))}
            </ul>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default function Servizi() {
  const { hash } = useLocation();
  useSeo("Servizi di social media, foto, video e Meta Ads in Lombardia", "Social Media Management, produzione foto e video, Advertising e Meta Ads, strategie di lancio per attività locali tra Como, Monza e Brianza, Varese e Lecco.");
  useEffect(() => {
    if (!hash) return undefined;
    const t = setTimeout(() => {
      const el = document.querySelector(hash);
      if (!el) return;
      if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -90 });
      else el.scrollIntoView();
    }, 700);
    return () => clearTimeout(t);
  }, [hash]);

  return (
    <>
      <PageHero
        testid="servizi-hero"
        eyebrow="Servizi"
        lines={["Cosa possiamo fare", "per la tua attività."]}
        intro="Quattro aree di lavoro che si parlano tra loro: strategia, produzione, advertising e lancio. Puoi affidarci un singolo servizio o l'intera comunicazione della tua attività."
      />
      <nav aria-label="Indice servizi" className="px-5 pb-16 sm:px-10 lg:px-16">
        <Reveal className="flex flex-wrap gap-x-8 gap-y-3">
          {SERVICES.map((s) => (
            <a key={s.id} href={`#${s.id}`} className="link-u text-sm text-ink/80" data-testid={`service-index-${s.id}`}>
              <span className="mr-2 font-serif text-teal">{s.n}</span>{s.title}
            </a>
          ))}
        </Reveal>
      </nav>
      {SERVICES.map((s, i) => <ServiceBlock key={s.id} s={s} i={i} />)}
      <Method eyebrowN="—" />
      <section className="px-5 py-24 sm:px-10 md:py-32 lg:px-16">
        <div className="grid grid-cols-12 lg:gap-x-10">
          <Lines lines={["Non sai da quale servizio partire?", "È normale. Ne parliamo insieme."]} className="col-span-12 text-3xl leading-[1.15] md:text-5xl lg:col-span-10" />
        </div>
      </section>
      <ContactCta />
    </>
  );
}
